module.exports = __webpack_public_path__ + "media/images/jumbotron-9d191c6a0f96844ecd0e52aacfdc7d0c.jpg";